(function () {

  if (window.__eveyGuardLoaded) return;
  window.__eveyGuardLoaded = true;

  const DEBUG = false;

  const LIMITED_PRODUCT_IDS = new Set([
    '15581404365132',
    '15525800542540'
  ]);

  const EXCLUDED_PRODUCT_IDS = new Set([
    '15698947768652',
    '15960249073996',
    '15965525213516' 
  ]);
  const WARNING_IDS = {
    drawer: 'evey-attendee-warning-drawer',
    cart: 'evey-attendee-warning-cart',
    fallback: 'evey-attendee-warning-fallback'
  };
  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    '#CartDrawer-Checkout',
    '#checkout',
    '.cart__checkout-button',
    '.cart__ctas button[type="submit"]',
    '.cart__ctas button',
    '.cart__footer button[type="submit"]',
    '.cart__footer button[name="checkout"]',
    '.cart-drawer__footer button[name="checkout"]',
    'a[href*="/checkout"]'
  ].join(',');


  const EVEY_MODAL_SELECTOR =
    '.evey-modal, #evey-modal, [class*="evey"][class*="modal"], [id*="evey"][id*="modal"]';
  const CART_ROOT_SELECTOR = [
    '[data-cart-drawer]',
    'cart-drawer',
    '#CartDrawer',
    '.cart-drawer',
    '.drawer',
    '.cart-notification',
    'cart-notification',
    '#cart-notification',
    '.mini-cart',
    '#mini-cart',
    '#main-cart-footer',
    '.cart__footer-wrapper',
    '.cart__footer',
    'form[action="/cart"]'
  ].join(',');
  let checkoutBlocked = false;
  let checkingCart = false;
  let debounceTimer = null;
  let observerTimer = null;
  let latestCart = null;




  let eveyFinishIntentAt = 0;
  let eveyAutoNavigated = false;
  const observedRoots = new WeakSet();
  const translations = {
    en: {
      title: 'Ticket details required',
      message: 'Please complete your ticket details before continuing to checkout.',
      action: 'Complete ticket details',
      loading: 'Loading form...',
      maxOne: 'Maximum 1 unit for this numbered item.'
    },
    es: {
      title: 'Datos de entradas requeridos',
      message: 'Por favor, completa los datos de tus entradas antes de continuar al pago.',
      action: 'Completar datos de entradas',
      loading: 'Cargando formulario...',
      maxOne: 'Máximo 1 unidad para este artículo numerado.'
    },
    fr: {
      title: 'Informations des billets requises',
      message: 'Veuillez compléter les informations de vos billets avant de passer au paiement.',
      action: 'Compléter les informations',
      loading: 'Chargement du formulaire...',
      maxOne: 'Maximum 1 unité pour cet article numéroté.'
    },
    de: {
      title: 'Ticketdaten erforderlich',
      message: 'Bitte vervollständige deine Ticketdaten, bevor du zur Kasse gehst.',
      action: 'Ticketdaten ausfüllen',
      loading: 'Formular wird geladen...',
      maxOne: 'Maximal 1 Einheit für diesen nummerierten Artikel.'
    },
    it: {
      title: 'Dati dei biglietti richiesti',
      message: 'Completa i dati dei tuoi biglietti prima di procedere al checkout.',
      action: 'Completa i dati',
      loading: 'Caricamento modulo...',
      maxOne: 'Massimo 1 unità per questo articolo numerato.'
    },
    pt: {
      title: 'Dados dos bilhetes obrigatórios',
      message: 'Preencha os dados dos seus bilhetes antes de continuar para o pagamento.',
      action: 'Preencher dados',
      loading: 'A carregar formulário...',
      maxOne: 'Máximo de 1 unidade para este artigo numerado.'
    }
  };
  function log() {
    if (DEBUG && window.console) {
      console.log('[Evey Guard]', ...arguments);
    }
  }
  function getLang() {
    const htmlLang = (document.documentElement.lang || '').split('-')[0].toLowerCase();
    if (translations[htmlLang]) return htmlLang;
    const pathLang = window.location.pathname.split('/').filter(Boolean)[0];
    if (translations[pathLang]) return pathLang;
    if (window.Shopify && Shopify.locale) {
      const shopifyLang = String(Shopify.locale).split('-')[0].toLowerCase();
      if (translations[shopifyLang]) return shopifyLang;
    }
    return 'en';
  }
  function getText() {
    return translations[getLang()] || translations.en;
  }
  function getCart() {
    return new Promise(function (resolve) {
      const xhr = new XMLHttpRequest();
      xhr.open('GET', '/cart.js?_=' + Date.now(), true);
      xhr.setRequestHeader('Cache-Control', 'no-cache, no-store, max-age=0');
      xhr.onload = function () {
        try {
          resolve(JSON.parse(xhr.responseText));
        } catch (error) {
          log('Cart JSON parse error', error);
          resolve({ items: [] });
        }
      };
      xhr.onerror = function () {
        resolve({ items: [] });
      };
      xhr.send();
    });
  }
  function isCartPage() {
    return window.location.pathname.indexOf('/cart') !== -1;
  }
  function isVisible(element) {
    if (!element) return false;
    const rect = element.getBoundingClientRect();
    const style = window.getComputedStyle(element);
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      style.display !== 'none' &&
      style.visibility !== 'hidden'
    );
  }
  function injectStyles() {
    if (document.getElementById('evey-guard-safe-css')) return;
    const style = document.createElement('style');
    style.id = 'evey-guard-safe-css';
    style.textContent = `
      .evey-attendee-warning {
        display: flex !important;
        gap: 12px !important;
        align-items: flex-start !important;
        margin: 12px 0 16px !important;
        padding: 14px 16px !important;
        border-radius: 10px !important;
        border: 1px solid #f2b94b !important;
        background: #fff4db !important;
        color: #3d2b00 !important;
        font-size: 14px !important;
        line-height: 1.4 !important;
      }
      .evey-attendee-warning__icon {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
        flex: 0 0 22px !important;
        width: 22px !important;
        height: 22px !important;
        border-radius: 999px !important;
        background: #f2a900 !important;
        color: #ffffff !important;
        font-weight: 700 !important;
        font-size: 14px !important;
      }
      .evey-attendee-warning__content {
        flex: 1 !important;
      }
      .evey-attendee-warning__title {
        margin: 0 0 4px !important;
        font-weight: 700 !important;
        color: #3d2b00 !important;
      }
      .evey-attendee-warning__message {
        margin: 0 0 8px !important;
        color: #3d2b00 !important;
      }
      .evey-attendee-warning__button {
        display: inline-block !important;
        color: #7a4b00 !important;
        font-weight: 700 !important;
        text-decoration: underline !important;
        cursor: pointer !important;
      }
      .evey-attendee-warning__button[aria-busy="true"] {
        opacity: 0.7 !important;
        cursor: wait !important;
      }
      .evey-checkout-disabled {
        opacity: 0.55 !important;
        cursor: not-allowed !important;
        pointer-events: auto !important;
      }
      .evey-limited-stepper-disabled {
        display: none !important;
      }
    `;
    document.head.appendChild(style);
  }
  function getCartDrawer() {
    const drawerSelectors = [
      '[data-cart-drawer]',
      'cart-drawer',
      '#CartDrawer',
      '.cart-drawer',
      '.drawer',
      '.cart-notification',
      'cart-notification',
      '#cart-notification',
      '.mini-cart',
      '#mini-cart'
    ].join(',');
    const candidates = Array.from(document.querySelectorAll(drawerSelectors));
    if (!candidates.length) return null;
    return candidates.find(function (element) {
      return (
        element.querySelector(CHECKOUT_SELECTOR) ||
        element.querySelector('.cart-item') ||
        element.querySelector('[id^="CartDrawer-Item-"]') ||
        element.querySelector('[id^="CartItem-"]') ||
        element.querySelector('input[name="updates[]"]') ||
        element.querySelector('.quantity__input')
      );
    }) || candidates[0];
  }
  function getCartPageArea() {
    return (
      document.querySelector('#main-cart-footer') ||
      document.querySelector('.cart__footer-wrapper') ||
      document.querySelector('.cart__footer') ||
      document.querySelector('form[action="/cart"]') ||
      document.querySelector('main')
    );
  }
  function getContexts() {
    const contexts = [];
    const drawer = getCartDrawer();
    if (drawer) {
      contexts.push({
        type: 'drawer',
        root: drawer,
        warningId: WARNING_IDS.drawer
      });
    }
    if (isCartPage()) {
      const cartArea = getCartPageArea();
      if (cartArea) {
        contexts.push({
          type: 'cart',
          root: cartArea,
          warningId: WARNING_IDS.cart
        });
      }
    }
    return contexts;
  }
  function getContextForElement(element) {
    const context = getContexts().find(function (candidate) {
      return candidate.root && candidate.root.contains(element);
    });
    if (context) return context;
    const fallbackRoot =
      element.closest(CART_ROOT_SELECTOR) ||
      element.closest('.cart__footer, .cart-drawer__footer, .drawer__footer, #main-cart-footer, .cart__footer-wrapper') ||
      element.parentElement;
    if (!fallbackRoot) return null;
    return {
      type: 'fallback',
      root: fallbackRoot,
      warningId: WARNING_IDS.fallback
    };
  }
  function getCheckoutButtonsInContext(context) {
    if (!context || !context.root) return [];
    return Array.from(context.root.querySelectorAll(CHECKOUT_SELECTOR)).filter(function (button) {
      return !button.closest('.evey-attendee-warning');
    });
  }
  function getCheckoutButtonInContext(context) {
    const buttons = getCheckoutButtonsInContext(context);
    if (!buttons.length) return null;
    return buttons.find(isVisible) || buttons[0];
  }
  function getEveyModal() {
    return document.querySelector(EVEY_MODAL_SELECTOR);
  }
  function revealEveyModal(modal) {
    modal.classList.remove('visually-hidden');
    modal.classList.remove('hidden');
    modal.removeAttribute('hidden');
    modal.setAttribute('aria-hidden', 'false');
    if (modal.style) {
      modal.style.display = '';
      modal.style.visibility = '';
      modal.style.opacity = '';
    }
    const focusable = modal.querySelector(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (focusable) {
      setTimeout(function () {
        focusable.focus();
      }, 100);
    }
    startTemporaryPolling(45000);
  }
  function openEveyModal(triggerButton) {
    const text = getText();
    const originalText = triggerButton ? triggerButton.textContent : '';
    let attempts = 0;
    const maxAttempts = 16;
    function setLoading() {
      if (!triggerButton) return;
      triggerButton.setAttribute('aria-busy', 'true');
      triggerButton.textContent = text.loading;
    }
    function restoreButton() {
      if (!triggerButton) return;
      triggerButton.removeAttribute('aria-busy');
      if (originalText) {
        triggerButton.textContent = originalText;
      } else {
        triggerButton.textContent = text.action;
      }
    }
    function tryOpen() {
      attempts += 1;
      const modal = getEveyModal();
      if (modal) {



        revealEveyModal(modal);
        restoreButton();
        return true;
      }
      if (attempts === 1) {
        setLoading();
        scheduleCheckBurst();
      }
      if (attempts < maxAttempts) {
        setTimeout(tryOpen, 220);
        return false;
      }
      restoreButton();
      alert('No encuentro el popup de Evey ahora mismo. Prueba a actualizar el carrito o recargar la página.');
      return false;
    }
    return tryOpen();
  }
  function getProductId(item) {
    return String((item && item.product_id) || '');
  }
  function isLimitedProductItem(item) {
    return LIMITED_PRODUCT_IDS.has(getProductId(item));
  }
  function isEventItem(item) {
    if (!item) return false;

    if (EXCLUDED_PRODUCT_IDS.has(String(item.product_id || ''))) {
      return false;
    }

    const text = [
      item.product_type,
      item.product_title,
      item.title,
      item.url,
      item.handle
    ].join(' ').toLowerCase();
    return (
      item.product_type === 'Event' ||
      text.includes('ticket') ||
      text.includes('tickets') ||
      text.includes('entrada') ||
      text.includes('entradas') ||
      text.includes('billet') ||
      text.includes('billets') ||
      text.includes('pass') ||
      text.includes('icons 2026')
    );
  }
  function parseMaybeJson(value) {
    if (typeof value !== 'string') return value;
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  }
  function countEveyEntriesFromValue(value) {
    const parsed = parseMaybeJson(value);
    if (Array.isArray(parsed)) {
      return parsed.length;
    }
    if (parsed && typeof parsed === 'object') {
      const possibleArrays = [
        parsed.attendees,
        parsed.attendee,
        parsed.guests,
        parsed.tickets,
        parsed.registrations,
        parsed.entries,
        parsed.forms,
        parsed.data
      ];
      for (let i = 0; i < possibleArrays.length; i += 1) {
        if (Array.isArray(possibleArrays[i])) {
          return possibleArrays[i].length;
        }
      }
      const numericKeys = Object.keys(parsed).filter(function (key) {
        return /^\d+$/.test(key);
      });
      if (numericKeys.length) return numericKeys.length;
    }
    return 0;
  }
  function getEveyCompletedCount(item) {
    const properties = (item && item.properties) || {};
    const eveyKeys = Object.keys(properties).filter(function (key) {
      return key.indexOf('_evey') === 0;
    });
    if (!eveyKeys.length) return 0;
    const counts = [];
    eveyKeys.forEach(function (key) {
      const valueCount = countEveyEntriesFromValue(properties[key]);
      if (valueCount > 0) {
        counts.push(valueCount);
      }
    });
    const keyIndexes = new Set();
    eveyKeys.forEach(function (key) {
      const match =
        key.match(/(?:attendee|guest|ticket|registration|entry|pass|evey)[^\d]*(\d+)/i) ||
        key.match(/[\[\._-](\d+)(?:[\]\._-]|$)/);
      if (match && match[1]) {
        keyIndexes.add(match[1]);
      }
    });
    if (keyIndexes.size > 0) {
      counts.push(keyIndexes.size);
    }
    if (counts.length) {
      return Math.max.apply(null, counts);
    }



    return Number((item && item.quantity) || 1);
  }
  function itemHasRequiredEveyData(item) {
    const quantity = Number((item && item.quantity) || 1);
    const completedCount = getEveyCompletedCount(item);
    log('Item Evey count:', {
      title: item && item.title,
      quantity: quantity,
      completedCount: completedCount,
      properties: item && item.properties
    });
    return completedCount >= quantity;
  }
  function cartNeedsEvey(cart) {
    const items = (cart && cart.items) || [];
    const eventItems = items.filter(isEventItem);
    if (!eventItems.length) return false;
    return !eventItems.every(itemHasRequiredEveyData);
  }
  function getCartItemRows(context) {
    if (!context || !context.root) return [];
    const selectors = [
      '.cart-item',
      '[id^="CartItem-"]',
      '[id^="CartDrawer-Item-"]',
      'cart-item',
      'tr'
    ].join(',');
    const rows = Array.from(context.root.querySelectorAll(selectors)).filter(function (row) {
      return row.querySelector(
        '.quantity, quantity-input, .quantity__input, input[name="updates[]"], button[name="plus"], button[name="minus"]'
      );
    });
    return rows.filter(function (row) {
      return rows.findIndex(function (other) {
        return other !== row && other.contains(row);
      }) === -1;
    });
  }
  function getLineIndexFromRow(row, context) {
    const id = row.getAttribute('id') || '';
    const idMatch = id.match(/(?:CartItem|CartDrawer-Item)-(\d+)/i);
    if (idMatch && idMatch[1]) {
      return Number(idMatch[1]) - 1;
    }
    const dataIndex =
      row.getAttribute('data-index') ||
      row.getAttribute('data-line') ||
      row.getAttribute('data-cart-item-index');
    if (dataIndex && !Number.isNaN(Number(dataIndex))) {
      return Number(dataIndex) - 1;
    }
    return getCartItemRows(context).indexOf(row);
  }
  function isRemoveControl(element) {
    if (!element) return false;
    const text = [
      element.textContent,
      element.getAttribute('aria-label'),
      element.getAttribute('title'),
      element.getAttribute('name'),
      element.getAttribute('href')
    ].join(' ').toLowerCase();
    return (
      element.closest('cart-remove-button') ||
      text.includes('remove') ||
      text.includes('delete') ||
      text.includes('trash') ||
      text.includes('papierkorb') ||
      text.includes('entfernen') ||
      text.includes('eliminar') ||
      text.includes('supprimer') ||
      text.includes('rimuovi') ||
      text.includes('remover') ||
      text.includes('/cart/change')
    );
  }
  function getQuantityContainers(row) {
    return Array.from(row.querySelectorAll(
      '.quantity, quantity-input, .quantity-selector, .cart-item__quantity, .cart-item__quantity-wrapper'
    ));
  }
  function getQuantityStepperButtons(row) {
    const buttons = new Set();
    const quantityContainers = getQuantityContainers(row);
    quantityContainers.forEach(function (container) {
      Array.from(container.querySelectorAll('button')).forEach(function (button) {
        if (!isRemoveControl(button)) {
          buttons.add(button);
        }
      });
    });
    Array.from(row.querySelectorAll('button')).forEach(function (button) {
      if (isRemoveControl(button)) return;
      const text = [
        button.textContent,
        button.innerText,
        button.getAttribute('aria-label'),
        button.getAttribute('name'),
        button.getAttribute('title')
      ].join(' ').toLowerCase();
      if (
        button.getAttribute('name') === 'plus' ||
        button.getAttribute('name') === 'minus' ||
        text.includes('increase') ||
        text.includes('decrease') ||
        text.includes('augmenter') ||
        text.includes('diminuer') ||
        text.includes('aumentar') ||
        text.includes('disminuir') ||
        text.includes('plus') ||
        text.includes('minus')
      ) {
        buttons.add(button);
      }
    });
    return Array.from(buttons);
  }
  function getQuantityInputs(row) {
    return Array.from(row.querySelectorAll(
      'input[name="updates[]"], .quantity__input, input[type="number"]'
    ));
  }
  function restoreRemoveControls(row) {
    Array.from(row.querySelectorAll(
      'cart-remove-button button, cart-remove-button a, a[href*="/cart/change"], button[name="remove"], [data-cart-remove], [data-remove]'
    )).forEach(function (control) {
      control.disabled = false;
      control.removeAttribute('aria-disabled');
      control.removeAttribute('data-evey-limited-ui');
      control.classList.remove('evey-limited-stepper-disabled');
      if (control.style) {
        control.style.pointerEvents = '';
      }
    });
  }
  function applyLimitedProductUi(cart) {
    const items = (cart && cart.items) || [];
    getContexts().forEach(function (context) {
      const rows = getCartItemRows(context);
      rows.forEach(function (row) {
        const lineIndex = getLineIndexFromRow(row, context);
        const item = items[lineIndex];
        const isLimited = item && isLimitedProductItem(item);
        row.classList.toggle('evey-limited-row', Boolean(isLimited));
        restoreRemoveControls(row);
        if (!isLimited) {
          getQuantityStepperButtons(row).forEach(function (button) {
            if (button.getAttribute('data-evey-limited-ui') === 'true') {
              button.disabled = false;
              button.removeAttribute('aria-disabled');
              button.removeAttribute('title');
              button.removeAttribute('data-evey-limited-ui');
              button.classList.remove('evey-limited-stepper-disabled');
            }
          });
          getQuantityInputs(row).forEach(function (input) {
            if (input.getAttribute('data-evey-limited-ui') === 'true') {
              input.removeAttribute('max');
              input.readOnly = false;
              input.style.pointerEvents = '';
              input.removeAttribute('data-evey-limited-ui');
            }
          });
          return;
        }
        getQuantityStepperButtons(row).forEach(function (button) {
          button.disabled = true;
          button.classList.add('evey-limited-stepper-disabled');
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('title', getText().maxOne);
          button.setAttribute('data-evey-limited-ui', 'true');
        });
        getQuantityInputs(row).forEach(function (input) {
          input.setAttribute('max', '1');
          input.readOnly = true;
          input.style.pointerEvents = 'none';
          input.setAttribute('data-evey-limited-ui', 'true');
        });
      });
    });
  }
  function getWarningPlacement(context, checkoutButton) {
    const ctas = checkoutButton.closest('.cart__ctas');
    if (ctas && ctas.parentElement && context.root.contains(ctas)) {
      return {
        parent: ctas.parentElement,
        before: ctas
      };
    }
    const footer = checkoutButton.closest(
      '.cart__footer, .cart-drawer__footer, .drawer__footer, #main-cart-footer, .cart__footer-wrapper'
    );
    if (footer && context.root.contains(footer)) {
      const footerCtas = footer.querySelector('.cart__ctas');
      if (footerCtas && footerCtas.parentElement) {
        return {
          parent: footerCtas.parentElement,
          before: footerCtas
        };
      }
      return {
        parent: footer,
        before: checkoutButton
      };
    }
    return {
      parent: checkoutButton.parentElement,
      before: checkoutButton
    };
  }
  function renderWarning(context) {
    const checkoutButton = getCheckoutButtonInContext(context);
    const text = getText();
    if (!checkoutButton) return;
    let warning = document.getElementById(context.warningId);
    if (!warning) {
      warning = document.createElement('div');
      warning.id = context.warningId;
      warning.className = 'evey-attendee-warning';
      warning.setAttribute('role', 'alert');
      warning.setAttribute('aria-live', 'polite');
      warning.innerHTML = `
        <div class="evey-attendee-warning__icon" aria-hidden="true">!</div>
        <div class="evey-attendee-warning__content">
          <p class="evey-attendee-warning__title"></p>
          <p class="evey-attendee-warning__message"></p>
          <a href="#" class="evey-attendee-warning__button"></a>
        </div>
      `;
    }
    warning.querySelector('.evey-attendee-warning__title').textContent = text.title;
    warning.querySelector('.evey-attendee-warning__message').textContent = text.message;
    warning.querySelector('.evey-attendee-warning__button').textContent = text.action;
    warning.querySelector('.evey-attendee-warning__button').removeAttribute('aria-busy');
    warning.querySelector('.evey-attendee-warning__button').onclick = function (event) {
      event.preventDefault();
      event.stopPropagation();

      openEveyModal(event.currentTarget);
    };
    const placement = getWarningPlacement(context, checkoutButton);
    if (placement.parent) {
      placement.parent.insertBefore(warning, placement.before || checkoutButton);
    }
  }
  function removeWarning(context) {
    const warning = document.getElementById(context.warningId);
    if (warning) {
      warning.remove();
    }
  }
  function cleanupLegacyWarnings() {
    [
      'evey-attendee-warning',
      'evey-attendee-warning-fallback'
    ].forEach(function (id) {
      const warning = document.getElementById(id);
      if (warning) {
        warning.remove();
      }
    });
  }
  function applyCheckoutState(blocked) {
    checkoutBlocked = Boolean(blocked);
    cleanupLegacyWarnings();
    const contexts = getContexts();
    contexts.forEach(function (context) {
      const buttons = getCheckoutButtonsInContext(context);
      buttons.forEach(function (button) {
        if (checkoutBlocked) {
          button.classList.add('evey-checkout-disabled');
          button.setAttribute('aria-disabled', 'true');
          button.setAttribute('data-evey-blocked', 'true');
        } else {
          button.classList.remove('evey-checkout-disabled');
          button.removeAttribute('aria-disabled');
          button.removeAttribute('data-evey-blocked');
        }
      });
      if (checkoutBlocked) {
        renderWarning(context);
      } else {
        removeWarning(context);
      }
    });
    if (checkoutBlocked && !contexts.length) {
      Array.from(document.querySelectorAll(CHECKOUT_SELECTOR)).forEach(function (button) {
        button.classList.add('evey-checkout-disabled');
        button.setAttribute('aria-disabled', 'true');
        button.setAttribute('data-evey-blocked', 'true');
      });
    }
  }
  function applyUI(cart) {
    injectStyles();
    applyLimitedProductUi(cart);
    applyCheckoutState(cartNeedsEvey(cart));
    ensureObservers();
  }
  function maybeFinishEveyNavigation(cart) {
    if (!eveyFinishIntentAt || eveyAutoNavigated) return;
    const elapsed = Date.now() - eveyFinishIntentAt;
    if (elapsed > 60000) {
      eveyFinishIntentAt = 0;
      return;
    }



    const items = (cart && cart.items) || [];
    if (!items.some(isEventItem)) return;
    if (cartNeedsEvey(cart)) return;
    if (elapsed < 2000) return;

    const themeGated = Array.from(document.querySelectorAll(
      'button[name="checkout"], #CartDrawer-Checkout, #checkout, .cart__checkout-button'
    )).some(function (b) { return b.disabled; });
    if (themeGated) {
      eveyFinishIntentAt = 0;
      return;
    }

    const agreement = document.getElementById('agreementCheckbox');
    if (agreement && !agreement.checked) {
      eveyFinishIntentAt = 0;
      return;
    }
    eveyAutoNavigated = true;
    window.location.href = '/checkout';
  }
  function checkCart() {
    if (checkingCart) return;
    checkingCart = true;
    getCart()
      .then(function (cart) {
        latestCart = cart;
        applyUI(cart);
        maybeFinishEveyNavigation(cart);
        log('Should block checkout:', checkoutBlocked, cart && cart.items);
      })
      .catch(function (error) {
        if (DEBUG && window.console) {
          console.error('[Evey Guard] cart error:', error);
        }
      })
      .finally(function () {
        checkingCart = false;
      });
  }
  function scheduleCheck(delay) {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(
      checkCart,
      typeof delay === 'number' ? delay : 200
    );
  }
  function scheduleCheckBurst() {
    scheduleCheck(120);
    setTimeout(checkCart, 450);
    setTimeout(checkCart, 900);
    setTimeout(checkCart, 1600);
  }
  function startTemporaryPolling(durationMs) {
    const endAt = Date.now() + (durationMs || 45000);
    function poll() {
      if (Date.now() > endAt || !checkoutBlocked) return;
      checkCart();
      setTimeout(poll, 1500);
    }
    setTimeout(poll, 1500);
  }
  function ensureObservers() {
    getContexts().forEach(function (context) {
      if (!context.root || observedRoots.has(context.root)) return;
      observedRoots.add(context.root);
      new MutationObserver(function () {
        clearTimeout(observerTimer);
        observerTimer = setTimeout(function () {
          if (checkoutBlocked) {
            applyCheckoutState(true);
          }
          if (latestCart) {
            applyLimitedProductUi(latestCart);
          }
        }, 150);
      }).observe(context.root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'open', 'aria-hidden', 'hidden', 'disabled']
      });
    });
  }
  function startGlobalObserver() {
    if (!document.body || observedRoots.has(document.body)) return;
    observedRoots.add(document.body);
    new MutationObserver(function () {
      clearTimeout(observerTimer);
      observerTimer = setTimeout(function () {
        ensureObservers();
        if (latestCart) {
          applyUI(latestCart);
        }
      }, 250);
    }).observe(document.body, {
      childList: true,
      subtree: true
    });
  }
  document.addEventListener(
    'click',
    function (event) {
      if (event.target.closest('.evey-attendee-warning')) return;


      if (event.target.closest(EVEY_MODAL_SELECTOR)) return;



      if (!event.isTrusted) return;
      const checkoutButton = event.target.closest(CHECKOUT_SELECTOR);
      if (!checkoutButton) return;
      const context = getContextForElement(checkoutButton);
      if (checkoutBlocked || checkoutButton.getAttribute('data-evey-blocked') === 'true') {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();


        scheduleCheckBurst();
        if (context) {
          renderWarning(context);
          const warning = document.getElementById(context.warningId);
          if (warning) {
            warning.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            });
          }
        }

        return false;
      }
    },
    true
  );
  document.addEventListener(
    'click',
    function (event) {


      const modal = event.target.closest(EVEY_MODAL_SELECTOR);
      if (!modal) return;
      const btn = event.target.closest('button, [role="button"], input[type="submit"]');
      if (!btn) return;
      const btnText = ((btn.textContent || '') + ' ' + (btn.getAttribute('aria-label') || '')).toLowerCase();
      const isClose = /(cerrar|close)/.test(btnText) || btnText.replace(/\s/g, '').length <= 1;
      if (isClose) return;
      if (
        btn.getAttribute('type') === 'submit' ||
        /(finalizar|checkout|pagar|payer|kasse|cassa|pagamento|continuar|continue|complete)/.test(btnText)
      ) {
        eveyFinishIntentAt = Date.now();
        eveyAutoNavigated = false;
        scheduleCheckBurst();
      }
    },
    true
  );
  document.addEventListener(
    'click',
    function (event) {
      const addButton = event.target.closest(
        'button[name="add"], [name="add"], button[type="submit"], .product-form__submit, [data-add-to-cart], [data-add-to-cart-button], [data-product-form-submit], [data-testid*="add-to-cart"]'
      );
      if (addButton) {
        scheduleCheckBurst();
      }
      if (
        event.target.closest('.quantity__button') ||
        event.target.closest('[name="plus"]') ||
        event.target.closest('[name="minus"]') ||
        event.target.closest('cart-remove-button') ||
        event.target.closest('[href*="/cart/change"]') ||
        event.target.closest('[data-cart-remove]') ||
        event.target.closest('[data-remove]')
      ) {
        scheduleCheckBurst();
      }
    },
    true
  );
  document.addEventListener(
    'submit',
    function (event) {
      const form = event.target;
      if (
        form &&
        form.matches &&
        (
          form.matches('form[action*="/cart/add"]') ||
          form.matches('product-form form') ||
          form.closest('product-form')
        )
      ) {
        scheduleCheckBurst();
      }
    },
    true
  );
  document.addEventListener(
    'change',
    function (event) {
      if (
        event.target.matches('input[name="updates[]"]') ||
        event.target.matches('.quantity__input') ||
        event.target.closest('.quantity')
      ) {
        scheduleCheckBurst();
      }
    },
    true
  );
  [
    'cart:updated',
    'cart:change',
    'cart:requestComplete',
    'cart:refresh',
    'cart:items:changed',
    'cart-drawer:updated',
    'cart-drawer:open',
    'cart-drawer:close',
    'evey:updated',
    'evey:attendees:updated',
    'evey:modal:close'
  ].forEach(function (eventName) {
    document.addEventListener(eventName, scheduleCheckBurst);
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      injectStyles();
      checkCart();
      ensureObservers();
      startGlobalObserver();
    });
  } else {
    injectStyles();
    checkCart();
    ensureObservers();
    startGlobalObserver();
  }



  (function hookCartRequests() {
    const CART_URL_RE = /\/cart\/(add|change|update|clear)/;
    try {
      const origFetch = window.fetch;
      if (origFetch) {
        window.fetch = function () {
          const url = String((arguments[0] && (arguments[0].url || arguments[0])) || '');
          const result = origFetch.apply(this, arguments);
          if (CART_URL_RE.test(url) && result && result.then) {
            result.then(function () { scheduleCheckBurst(); }).catch(function () {});
          }
          return result;
        };
      }
      const origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        if (CART_URL_RE.test(String(url || ''))) {
          this.addEventListener('loadend', function () { scheduleCheckBurst(); });
        }
        return origOpen.apply(this, arguments);
      };
    } catch (error) {
      log('hookCartRequests error', error);
    }
  })();



  setInterval(function () {
    if (checkoutBlocked && !document.hidden) {
      checkCart();
    }
  }, 3000);
  window.eveyGuardRefresh = checkCart;
  window.eveyGuardOpenModal = openEveyModal;
})();